import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import constants from '../../../constants/messages/pt-BR';
import Typography from '../Typography';
import Rating from '../Rating';
import styles from './readreview-tw-styles';
import { Button } from '../Button';
import config from '../../../config';
import { cookieName, readCookie, setCookie, deleteCookie } from './ReadReviewUtil';
import path from '../../../assets/images/svgImages.svg';
import ALP_Constants from '../../Brand/ArticleListingPage/constants'

const spritePath = typeof path === 'string' ? path : path?.src || '';

class ReviewItem extends React.Component {
  static propTypes = {
    itemData: PropTypes.oneOfType([PropTypes.array]),
    locale: PropTypes.string.isRequired,
    store: PropTypes.oneOfType([PropTypes.object]).isRequired,
  };

  static defaultProps = {
    itemData: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      reviewHelpfull: {},
    };
  }

  componentDidMount() {
    this.updateReviewHelpfulState();
  }

  submitFeedback = (feedback, item) => {
    const { store, locale } = this.props;
    const { reviewHelpfull } = this.state;
    const currentVote = reviewHelpfull[item.Id];
    const newVoteValue = feedback === config.bazaarvoice.Positive ? '1' : '-1';

    // If clicking the same button again, remove the vote (toggle off)
    if (currentVote === newVoteValue) {
      deleteCookie(item.Id);
      reviewHelpfull[item.Id] = undefined;
      this.setState({ reviewHelpfull });
      return;
    }

    // If no vote or switching vote, submit to API
    if (!currentVote || currentVote !== newVoteValue) {
      store.submitFeedbackByID(feedback, item.Id, locale);
      // Update state immediately to reflect the vote
      reviewHelpfull[item.Id] = newVoteValue;
      this.setState({ reviewHelpfull });
    }
  };

  dateFormatter(item) {
    let monthInWord = [
      'Jan',
      'Feb',
      'March',
      'April',
      'May',
      'June',
      'July',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return (
      new Date(item.SubmissionTime).getDate() +
      ' ' +
      monthInWord[parseInt(new Date(item.SubmissionTime).getMonth())] +
      ', ' +
      new Date(item.SubmissionTime).getFullYear()
    );
  }

  updateReviewHelpfulState() {
    const { itemData } = this.props;
    itemData.map(item => {
      const cookieValue = readCookie(item.Id);
      let { reviewHelpfull } = this.state;
      reviewHelpfull[item.Id] = cookieValue;
      this.setState({
        reviewHelpfull,
      });
    });
  }

  render() {
    const { itemData } = this.props;
    const { reviewHelpfull } = this.state;
    return (
      <div className={styles.reviewitem.wrapperMargin} role="list" aria-label="Lista de avaliações">
        {itemData.map((item, i) => {
          const cookieValue = reviewHelpfull[item.Id];
          return (
            <div key={i} className={styles.reviewitem.wrapper} role="listitem" aria-label={`Avaliação de ${item.UserNickname}`}>
              <div className={styles.reviewitem.leftWrapperDiv}>
                <div className={styles.reviewItemDivOne} />
                <div className={styles.reviewItemDivTwo}>
                  <div className={styles.reviewItemDivThree}>
                    <Typography className={styles.reviewitem.usernickname}>
                      {item.UserNickname}
                    </Typography>
                  </div>
                  <div className={styles.reviewitem.ratingTime}>
                    <Typography>{this.dateFormatter(item)}</Typography>
                  </div>
                </div>
                <div className={styles.reviewitem.ratingWrapper}>
                  <div className={styles.reviewitem.ratingWidth}>
                    <Rating
                      rating={item.Rating}
                      className={styles.reviewitem.ratingLink}
                    />
                  </div>
                </div>
                <div className={styles.reviewitem.reviewWrapper}>
                  <Typography className={styles.reviewitem.reviewtitle}>
                    {item.Title}
                  </Typography>
                  <Typography className={styles.reviewitem.reviewtext} style={{overflowWrap:"break-word"}}>
                    {item.ReviewText}
                  </Typography>
                  {item.IsSyndicated && (
                    <div className={styles.reviewitem.reviewWrapper}>
                      <Typography className={styles.reviewitem.reviewtext}>
                        {constants.syndicationText}
                        {item.SyndicationSource && item.SyndicationSource.Name}
                      </Typography>
                    </div>
                  )}
                  {item.ContextDataValues &&
                    item.ContextDataValues.IncentivizedReview &&
                    item.ContextDataValues.IncentivizedReview.Value ===
                      'True' && (
                      <div className={styles.reviewitem.reviewWrapper}>
                        <Typography className={styles.reviewitem.reviewtext}>
                          {constants.incentivizedText}
                        </Typography>
                      </div>
                    )}
                  <Typography
                    className={styles.reviewitem.usefultext}
                    component="div"
                  >
                    <FormattedMessage
                      id={constants.reviewHelpful}
                      defaultMessage={constants.reviewHelpful}
                    />
                    <Button
                      className={styles.reviewitem.submitFeedback}
                      onClick={() =>
                        this.submitFeedback(config.bazaarvoice.Positive, item)
                      }
                      aria-label={cookieValue === '1' ? `${ALP_Constants.GOSTEI_BOTAO}, selected` : `${ALP_Constants.GOSTEI_BOTAO}, not selected`}
                      role="button"
                    >
                      <div className={styles.reviewitem.thumbsUp}>
                        <svg
                          className={classNames(
                            styles.reviewitem.thumbsUpimg,
                            'w-18 h-18'
                          )}
                        >
                          <use xlinkHref={`${spritePath}#helpful`} />
                        </svg>
                      </div>
                    </Button>
                    <span className={styles.reviewitem.thumbCount}>
                      {cookieValue === '1'
                        ? item.TotalPositiveFeedbackCount + 1
                        : item.TotalPositiveFeedbackCount}
                    </span>
                    <Button
                      className={styles.reviewitem.submitFeedback}
                      onClick={() =>
                        this.submitFeedback(config.bazaarvoice.Negative, item)
                      }
                      aria-label={cookieValue === '-1' ? `${ALP_Constants.NAO_GOSTEI_BOTAO}, selected` : `${ALP_Constants.NAO_GOSTEI_BOTAO}, not selected`}
                      role="button"
                    >
                      <div className={styles.reviewitem.thumbsDown}>
                        <svg className={classNames(styles.reviewHelp)}>
                          <use xlinkHref={`${spritePath}#nothelpful`} />
                        </svg>
                      </div>
                    </Button>
                    <span className={styles.reviewitem.thumbCount}>
                      {cookieValue === '-1'
                        ? item.TotalNegativeFeedbackCount + 1
                        : item.TotalNegativeFeedbackCount}
                    </span>
                  </Typography>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default observer(ReviewItem);
